"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RailCarBulk = function RailCarBulk(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54,15.2H50.75V8.83l4-5.17V.8A.8.8,0,0,0,54,0H.84A.8.8,0,0,0,0,.8V3.6L4,8.83V15.2H.81a.78.78,0,1,0,0,1.56h3.3a3.92,3.92,0,1,0,4.05,0H12A3.91,3.91,0,1,0,18,20.09a4,4,0,0,0-.08-.78.8.8,0,0,0,.75.52H35.89a.79.79,0,0,0,.65-.36,4.2,4.2,0,0,0-.06.62,3.91,3.91,0,1,0,5.93-3.33h3.87a3.91,3.91,0,1,0,4.06,0H54a.78.78,0,1,0,0-1.56Zm-5.66,2.53A2.36,2.36,0,1,1,46,20.09,2.36,2.36,0,0,1,48.31,17.73ZM1.6,1.57H53.19V3.12l-4,5.18v6.9H41.06V9.67a.78.78,0,1,0-1.56,0V15.2H15.28V9.67a.78.78,0,1,0-1.56,0V15.2H5.6V8.31l-4-5.23ZM40.39,17.73A2.36,2.36,0,1,1,38,20.09,2.36,2.36,0,0,1,40.39,17.73Zm-24,2.36a2.36,2.36,0,1,1-2.35-2.36A2.35,2.35,0,0,1,16.41,20.09ZM6.14,17.73a2.36,2.36,0,1,1-2.35,2.36A2.36,2.36,0,0,1,6.14,17.73Zm9.94-1h1.75V19a.75.75,0,0,0,.05.26A3.88,3.88,0,0,0,16.08,16.76Zm20.61,0h1.68a3.87,3.87,0,0,0-1.68,2.11Z"
  }));
};

var _default = RailCarBulk;
exports["default"] = _default;